import React from "react";
import type { U2000AgingBucket } from "../../../u2000Core/constants/U2000AgingBuckets";
import {
  u3134FormatTecAgeProjectLabel,
  u3134TecAgeTotalsForBucket,
  type U3134TecAgeCustomerDetailReport,
} from "../../U3134Service";
import {
  U3134TecAgeBucketMetricRows,
  U3134TecAgeBucketTableHeader,
} from "./U3134TecAgeBucketTable";

export interface U3134TecAgeCustomerExpandedTableProps {
  customerDetail: U3134TecAgeCustomerDetailReport;
  customerLabel: string;
  selectedBucket?: U2000AgingBucket | null;
}

const U3134TecAgeCustomerExpandedTable: React.FC<U3134TecAgeCustomerExpandedTableProps> = ({
  customerDetail,
  customerLabel,
  selectedBucket = null,
}) => {
  const customerTotals = selectedBucket
    ? u3134TecAgeTotalsForBucket(customerDetail.buckets, selectedBucket)
    : customerDetail.totals;
  const projects = customerDetail.projects ?? [];

  return (
    <div className="overflow-x-auto">
      <table className="w-full min-w-160 text-xs">
        <U3134TecAgeBucketTableHeader
          selectedBucket={selectedBucket}
          alignPeriodWithAmountLineCount
        />
        <tbody>
          <U3134TecAgeBucketMetricRows
            buckets={customerDetail.buckets}
            totals={customerTotals}
            selectedBucket={selectedBucket}
            variant="compact"
            layout="singleRow"
            countLabel={customerLabel}
            countLabelClassName="bg-gray-50 font-semibold text-gray-900"
          />
          {projects.map((pr, index) => {
            const projectLabel = u3134FormatTecAgeProjectLabel(pr.project);
            const projectTotals = selectedBucket
              ? u3134TecAgeTotalsForBucket(pr.buckets, selectedBucket)
              : pr.totals;
            return (
              <U3134TecAgeBucketMetricRows
                key={pr.project.id}
                buckets={pr.buckets}
                totals={projectTotals}
                selectedBucket={selectedBucket}
                variant="compact"
                layout="singleRow"
                countLabel={projectLabel}
                countLabelClassName="pl-3 font-medium text-gray-700 border-l-2 border-gray-200"
                firstProjectRow={index === 0}
              />
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default U3134TecAgeCustomerExpandedTable;
